import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './styles/index.css'
import App from './App.tsx'

const container = document.getElementById('root')!

if (container.hasChildNodes()) {
  // Hydrate für SSG/SSR (Production)
  hydrateRoot(container, 
    <StrictMode>
      <App />
    </StrictMode>
  )
} else {
  // Normales Rendering für Dev (Client-Side)
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
